<!-- adduser-cost.component.html -->
<div class="adduser-container">
  <h2 class="header-title">{{selectedPackage.packageName}} <span class="plan-type">Yearly</span></h2>

  <form class="adduser-form">
    <!-- Row 1: Number of Users -->
    <div class="form-row">
      <h2>Number of Users</h2>
      <h3>Add User</h3>
      <h2>Amount Summary</h2>
    </div>
    <div class="form-row">
      <div class="left">
        <label class="radio-block">
          <input type="radio" name="plan" [(ngModel)]="selectedPlan" [value]="'perUser'" (change)="userTypeChanged()" />
          <div class="plan-info">
            <div *ngFor="let price of selectedPackage.pricing">
              <ng-container *ngIf="price.maxUsers > 0">
                Upto {{price.maxUsers}} Users {{price.pricePerUserPerMonth | currency:'INR':'symbol' }} per month /
                biilled annually
              </ng-container>
              <ng-container *ngIf="price.maxUsers === 0">
                For 5 and above users {{price.pricePerUserPerMonth | currency:'INR':'symbol' }} per month / billed
                annually
              </ng-container>
            </div>
          </div>

        </label>
      </div>

      <div class="middle" *ngIf="selectedPlan === 'perUser'">
        <!-- <div class="adduser-label">Add User</div> -->
        <div class="user-counter">
          <button type="button" (click)="decrementUser()" [disabled]="selectedPlan !== 'perUser'">−</button>
          <span>{{ userCount < 10 ? '0' + userCount : userCount }}</span>
              <button type="button" (click)="incrementUser()" [disabled]="selectedPlan !== 'perUser'">+</button>
        </div>
      </div>

      <div class="right amount-cell" style="font-weight: 700;" *ngIf="selectedPlan === 'perUser'">
        {{annualCost | currency:'INR':'symbol' }}
      </div>
    </div>

    <!-- Row 2: Unlimited -->
    <div class="form-row">
      <div class="left">
        <label class="radio-block">
          <input type="radio" name="plan" [(ngModel)]="selectedPlan" [value]="'unlimited'"
            (change)="userTypeChanged()" />
          <div class="plan-info">Unlimited Users - {{getUnlimitedUsersPrice()?.pricePerUserPerMonth |
            currency:'INR':'symbol'}}</div>
        </label>
      </div>
      <div class="middle"></div>
      <div class="right amount-cell" style="font-weight: 700;" *ngIf="selectedPlan === 'unlimited'">
        {{getUnlimitedUsersPrice()?.pricePerUserPerMonth | currency:'INR':'symbol'}}
      </div>
    </div>

    <hr />

    <!-- Tax Section -->
    <div class="d-flex justify-content-end align-item-center">
      <div class="tax-row"><span style="margin-top: 15px; margin-right: 5px; font-size: 14px;">Select GST type</span>
        <select class="number-value" [(ngModel)]="selectGstType">
          <option [value]="'cgstAndSgst'">CGST & SGST</option>
          <option [value]="'igst'">IGST</option>
        </select>
      </div>
      <ng-container *ngIf="selectGstType === 'cgstAndSgst'">
        <div class="tax-row"><span style="margin-top: 15px; margin-right: 5px; font-size: 14px;">CGST 9%</span><span
            class="number-value">
            {{ cgst | currency:'INR':'symbol' }}/-</span></div>
        <div class="tax-row"><span style="margin-top: 15px; margin-right: 5px; font-size: 14px;">SGST 9%</span><span
            class="number-value">
            {{ sgst | currency:'INR':'symbol' }}/-</span></div>
      </ng-container>
      <ng-container *ngIf="selectGstType === 'igst'">
        <div class="tax-row"><span style="margin-top: 15px; margin-right: 5px; font-size: 14px;">IGST 18%</span><span
            class="number-value">
            {{ igst | currency:'INR':'symbol' }}/-</span></div>
      </ng-container>


      <div class="tax-row "><span style="margin-top: 15px; margin-right: 5px; font-size: 14px;">Total Amount</span><span
          class="number-value">{{ totalAmount | currency:'INR':'symbol' }}/- </span></div>

      <div class="btn-wrap">
        <button class="proceed-btn" type="button" (click)="goToNextStep()">Proceed</button>
      </div>
    </div>

  </form>
</div>